import { RootState } from '../../store';

export const stateSelector = (state: RootState) => state.user;
export const userDataSelector = (state: RootState) => state.user.data;
export const userIdSelector = (state: RootState) => userDataSelector(state).id;
export const loadingSelector = (state: RootState) =>
  stateSelector(state).isLoading;
export const globalSelectedMachinesSelector = (state: RootState) =>
  stateSelector(state).machineGroups.selectedMachines;
export const getUserCompaniesSelector = (state: RootState) =>
  stateSelector(state).companies;
export const getUserMachineGroupsSelector = (state: RootState) =>
  stateSelector(state).machineGroups;
